import { render, staticRenderFns } from "./PLayoutScale.vue?vue&type=template&id=2abc8392&scoped=true&"
import script from "./PLayoutScale.vue?vue&type=script&lang=js&"
export * from "./PLayoutScale.vue?vue&type=script&lang=js&"
import style0 from "./PLayoutScale.vue?vue&type=style&index=0&id=2abc8392&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abc8392",
  null
  
)

export default component.exports